import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2"
import '../../styles/tarjetaContenedor.css'

import {FaHospitalUser} from 'react-icons/fa';
/**
 * Objetos
 */
//Importación de las funcionalidades del objeto de tipo unidadHospitalaria
import { getUnidadHospitalariaName, getUnidadHospitalariaValue} from '../../objects/unidadHospitalaria';
import { deletePaciente } from '../../objects/patient';
import { createLog } from '../../objects/logs';

/**
 * Componentes
 */
//Componente que contiene el modal que permite dar salida a un paciente
import PacienteModal from './pacienteModal';


/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
import { descrifrar, getDateString } from '../../utils/functions';

/**
 * Componente que contiene la información y funcionalidad asignada a un paciente pendiente de salida de quirófano
 * @param {Object} param0 Recibe un objeto de tipo paciente con su respectiva información y la información de la sesión
 * @returns Component Devuelve el componente con los elementos y funcionalidad requeridos
 */
const PacientePendienteAlta = ({paciente,userLevel,nomHospitalUser,uhList,setPacienteSeleccionado,
    pacienteSeleccionado,pacienteIsRecuperacion,setPacienteIsRecuperacion,pacienteTelefonoIsVisible,
    setPacienteTelefonoIsVisible,pacienteTieneContactos,setPacienteTieneContactos,
    pacienteContactos,setPacienteContactos,name,pacienteUH,setPacienteUH,pacienteIsEspecial,
    setPacienteIsEspecial,isRecuperacionOrigen,setIsRecuperacionOrigen,isMostrarPacientes,
    pacienteUnidadHospitalariaName,setPacienteUnidadHospitalariaName}) => {
    
    //Estado que almacena la información del paciente
    const {NumeroDePaciente,UnidadHospitalaria,NumeroTelefono,patientname,birthdate} = paciente;

    //Estado que almacena si la lista de contactos de un paciente
    const [contactosList,setContactosList] = useState([])
    //Estado que almacena si el paciente corresponde a la unidad hospitalaria del usuario
    const [correspondeHospital,setCorrespondeHospital] = useState(false)
    //Estado que almacena si el paciente pertenece al tipo de asignación del usuario logeado
    const [isAsignacion,setIsAsignacion]=useState(false)
    //Estado que almacena si el paciente se encuentra en caso especial de atención
    const [isEspecial,setIsEspecial] = useState(false)
    //Estado que almacena si el estado anterior del paciente es quirófano
    const [isQuirofanoOrigen,setIsQuirofanoOrigen] = useState(false)
    //Estado que almacena si el paciente se encuentra en etapa de recuperación
    const [isRecuperacion, setIsRecuperacion] = useState(false)
    //Estado que almacen si el paciente ya se encuentra fuera del area de surgeryroom
    const [isSalida,setIsSalida] = useState(false)
    //Estado que almacena si el modal de dar salida es visible
    const [isVisible, setIsVisible] = useState(false)
    //Estado que almacen la clase asignada a la tarjeta de paciente
    const [modalClassName,setModalClassName] = useState("")
    //Estado que almacena la fecha de nacimiento de un paciente
    const [pacienteFechaNacimiento,setPacienteFechaNacimiento]=useState("")
    //Estado que almacena si el teléfono del paciente será visible
    const [telefonoIsVisible,setTelefonoIsVisible] = useState(false)
    //Estado que almacena si el paciente cuenta con lista de contactos
    const [tieneContactos,setTieneContactos] = useState(false)
    //Estado que almacena el nombre de la unidad hospitalaria a la que esta asiganado el paciente
    const [unidadHospitalariaNombre, setUnidadHospitalariaNombre] = useState("")
    
    
    //Estilo asignado al icono de la tarjeta para pacientes en quirófano
    const styleActive = { color: "black", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}
    //Estilo asignado al icono de la tarjeta para pacientes en quirófano
    //const styleComplicacion = { color: "#9B111B", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}
    const styleComplicacion = { color: "#e12f3b", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}
    //Estilo asignado al icono de la tarjeta para pacientes en recuperación
    const styleRecuperacion = { color: "#FFBF00", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}

    useEffect(()=>{
        if(paciente){//Se verifica que se haya seleccionado un paciente
            if(paciente.Status === "Recuperacion"){//Se verifica si el estatus del paciente es Recuperación
                setIsRecuperacion(true)
                setPacienteIsRecuperacion(true)
                setIsSalida(false)
                setIsEspecial(false)
                setPacienteIsEspecial(false)
                setIsQuirofanoOrigen(false)
                if(isMostrarPacientes){
                    setIsAsignacion(false)
                }
                else{
                    setIsAsignacion(true)
                }
            }
            else{
                if(paciente.Status === "Salida" || paciente.Status === "Especial"){//Si el paciente tiene estatus salida o especial se limpian los estados
                    if(paciente.Status === "Especial"){
                        setIsRecuperacion(false)
                        setPacienteIsRecuperacion(false)
                        setIsSalida(false)
                        setIsEspecial(true)
                        setPacienteIsEspecial(true)
                        
                        if(paciente.lastEstatus === "Quirófano"){
                            setIsQuirofanoOrigen(true)
                            if(isMostrarPacientes){
                                setIsAsignacion(true)
                            }
                            else{
                                setIsAsignacion(false)
                            }
                        }
                        else{
                            setIsQuirofanoOrigen(false)
                            if(isMostrarPacientes){
                                setIsAsignacion(false)
                            }
                            else{
                                setIsAsignacion(true)
                            }
                        }
                    }
                    else{
                        setIsRecuperacion(false)
                        setPacienteIsRecuperacion(false)
                        setIsSalida(true)
                        setIsEspecial(false)
                        setPacienteIsEspecial(false)
                        setIsQuirofanoOrigen(false)
                    }
                }
                else{//Se asignan valores para paciente en quirófano
                    setIsRecuperacion(false)
                    setPacienteIsRecuperacion(false)
                    setIsSalida(false)
                    setIsEspecial(false)
                    setPacienteIsEspecial(false)
                    if(isMostrarPacientes){
                        setIsAsignacion(true)
                    }
                    else{
                        setIsAsignacion(false)
                    }
                }
            }

            if(paciente.contacts){//Se verifica si el paciente cuenta con contactos registrados
                //Se muestran la sección de contactos con los que tiene asignados
                setTieneContactos(true)
                setContactosList(paciente.contacts)
            }
            else{//Se oculta la sección de contactos
                setTieneContactos(false)
                setContactosList([])
            }
        }
        else{//Se limpian los estados
            setIsRecuperacion(false)
            setPacienteIsRecuperacion(false)
            setIsSalida(false)
        }
    },[paciente,setPacienteIsRecuperacion,setPacienteIsEspecial,userLevel,isMostrarPacientes])

    useEffect(()=>{
        if(birthdate){//Se verifica que el paciente tenga fecha de nacimiento registrada
            if(birthdate.toUpperCase() !== "No Disponible".toUpperCase()){//Se verifica que tenga una fecha valida registrada
                //setPacienteFechaNacimiento(birthdate.split(' ')[0])
                //Se muestra en formato dd-mm-yyyy la fecha que tiene registrada el paciente
                let fechaCompleta = birthdate.split(' ')[0]
                setPacienteFechaNacimiento(getDateString(birthdate))
                setPacienteFechaNacimiento(fechaCompleta.split('-')[2] + "-" + fechaCompleta.split('-')[1] + "-" + fechaCompleta.split('-')[0])
            }
            else{//Se muestra la fecha que tiene registrada el paciente
                setPacienteFechaNacimiento(birthdate)
            }
        }
        else{//Se asigna el valor No Disponible
            setPacienteFechaNacimiento("No Disponible")
        }
    },[birthdate])

    useEffect(()=>{
        if(userLevel === "superuser"){//Verificar si el usuario tiene acceso total a los pacientes
            //Se asigna la clase de tarjeta para la vista de superuser, se indica que se puede mostrar el paciente y se muestra la sección de teléfono de contacto
            setModalClassName("itemblog")
            setTelefonoIsVisible(true)
            setPacienteTelefonoIsVisible(true)
            let uhName = getUnidadHospitalariaValue(UnidadHospitalaria)
            setUnidadHospitalariaNombre(uhName)
            setPacienteUH(uhName)
            setCorrespondeHospital(true)
        }
        else{//Usuario de tipo administrador o normal
            if(userLevel === "administrador"){//Se verifica si el usuario tiene acceso de administrador
                //Se asigna la clase de tarjeta para la vista de administrador y se muestra la sección e teléfono de contacto
                setModalClassName("itemblog")
                setTelefonoIsVisible(true)
                setPacienteTelefonoIsVisible(true)
            }
            else{//Usuario con acceso normal
                //Se asigna la clase de tarjeta para la vista de user normal y se oculta la sección de teléfono de contacto
                setModalClassName("itemblogUserNormal")
                setTelefonoIsVisible(false)
                setPacienteTelefonoIsVisible(false)
            }

            let uhName = getUnidadHospitalariaValue(UnidadHospitalaria)

            if(getUnidadHospitalariaName(descrifrar(nomHospitalUser).toString(),uhList) === 
                getUnidadHospitalariaName(uhName,uhList)){//Se verifica si el paciente pertence a la unidad hospitalaria a la que esta asignado el usuario
                //se indica que se puede mostrar el paciente
                setUnidadHospitalariaNombre(uhName)
                setPacienteUH(uhName)
                setCorrespondeHospital(true)
            }
            else{//No corresponde a la misma unidad hospitalaria
                //Se oculta la tarjeta del paciente
                setCorrespondeHospital(false)
            }
        }
    },[userLevel,nomHospitalUser,UnidadHospitalaria,uhList,setPacienteTelefonoIsVisible,setPacienteUH])

    /**
     * Función que permite ocultar el modal de dar alta
     * @returns Devuelve el estado del objeto
     */
    const hideModal = () => setIsVisible(false);

    /**
     * Función que atrapa la solicitud para informar salida de quirófano de un paciente
     * @param {Object} paciente Objeto con la información del paciente
     * @returns void
     */
    const handleSalidaClick = (paciente) => (event) => {
        event.preventDefault()
        setPacienteUnidadHospitalariaName(getUnidadHospitalariaName(unidadHospitalariaNombre,uhList))
        if(document.getElementById('modal').style.display === "none" || !document.getElementById('modal').style.display){
            setPacienteSeleccionado(paciente)
            if(paciente.Status === "Recuperacion"){
                setPacienteIsRecuperacion(true)
                setPacienteIsEspecial(false)
                setIsRecuperacionOrigen(false)
            }
            else{
                setPacienteIsRecuperacion(false)
                if(paciente.Status === "Especial"){
                    setPacienteIsEspecial(true)
                    if(paciente.lastEstatus === "Recuperación"){
                        setIsRecuperacionOrigen(true)
                    }
                    else{
                        setIsRecuperacionOrigen(false)
                    }
                }
                else{
                    setPacienteIsEspecial(false)
                    setIsRecuperacionOrigen(false)
                }
            }

            if(paciente.contacts){
                if(paciente.contacts.length > 0){
                    setPacienteTieneContactos(true)
                    setPacienteContactos(paciente.contacts)
                }
                else{
                    setPacienteTieneContactos(false)
                    setPacienteContactos([])
                }
            }
            else{
                setPacienteTieneContactos(false)
                setPacienteContactos([])
            }

            document.getElementById('modal').style.display='block'
            setIsVisible(true)
        }
    }

    /**
     * Función que muestra la lista de contactos que tiene registrada un paciente
     * @returns Devuelve el estado del objeto
     */
    const handleContactosClick = () => (event) => {
        event.preventDefault()
        let contactos = ""
        contactos += "<h2 class=modalPacienteTitle>Contactos "+paciente.NumeroDePaciente+"</h2>"
        contactos += "<h1 class='info_itemblog'>"+patientname+"</h1>"
        contactos += "<h1 class='info_itemblog'>"+paciente.NumeroTelefono+"</h1>"
        for(let i=0; i< contactosList.length;i++){
            contactos += "<h1 class='info_itemblog'>"+contactosList[i]+"</h1>"
        }
        Swal.fire({
            html:
              contactos,
            showCloseButton: true,
            showConfirmButton:false,
            customClass: 'swal-height'
          })
    }

    const handleCancelarCirugiaClick = (paciente) => (event) => {
        event.preventDefault()
        let modalBody = ""
        modalBody += "<h2 class=info_itemconfirmTitle>Favor de ingresar el número de atención del paciente:</h2>"
        modalBody += "<h2 class=info_itemconfirm>"+paciente.NumeroDePaciente + " - " +paciente.patientname+"</h2>"
      
        Swal.fire({
          html:modalBody,
          //title: "Favor de ingresar el número de atención del paciente:",
          text: paciente.NumeroDePaciente + " - " +paciente.patientname,
          input: "text",
          showCancelButton: true,
          confirmButtonText: "Guardar",
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#04afaa",
          allowOutsideClick:false,
          customClass: 'swal-confirm',
          preConfirm: (text) => {
            return new Promise((resolve) => {
              if (!text) {
                Swal.showValidationMessage('No ha proporcionado el número de atención')
              }
              else{
                if(text !== paciente.NumeroDePaciente){
                  Swal.showValidationMessage('El número de atención proporcionado no coicide con el del paciente seleccionado')
                }
              }
              resolve()
            })
          },
        })
        .then(resultado => {
          if (resultado.value) {
              if(resultado.value === paciente.NumeroDePaciente){
                Swal.fire({
                  title: "¿Desea dar de baja al paciente " + paciente.NumeroDePaciente + " " +paciente.patientname + "?",
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonColor: '#04afaa',
                  confirmButtonText: 'Aceptar',
                  denyButtonText: `Cancelar`,
                  cancelButtonText:`Cancelar`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    reportarCancelarCirugia(paciente)
                  }
                })
              }
              else{
                Swal.fire({
                  icon: 'warning',
                  title: 'Error',
                  text: "El número de atención proporcionado no coicide con el del paciente seleccionado",
                })
              }
          }
        });
      }

      const reportarCancelarCirugia = async (paciente) => {
        let mensaje = "Se ha dado de baja el paciente de manera exitosa"
      
        let ultimoEstatus = "Quirófano"
        solicitarCambioEstado()
        async function solicitarCambioEstado(){
          const response = await deletePaciente(paciente)
          if(response === "success"){
            let date = new Date()
            createLog(paciente,
              sessionStorage.getItem('id'),
              descrifrar(name).toString(),
              "Report status to Baja",
              date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate(),
              date.getHours()+":"+date.getMinutes()+":"+date.getSeconds()+":"+date.getMilliseconds(),
              ultimoEstatus
            )
            Swal.fire({
              icon: 'success',
              title: 'Momento de quirófano',
              text: mensaje,
              confirmButtonText: "Aceptar",
              confirmButtonColor: "#04afaa",
            })
          }
          else{
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: response,
            })
          }
        }
      }

    return(
        <>
            {
                (NumeroDePaciente && UnidadHospitalaria && correspondeHospital && !isSalida && isAsignacion)?
                    (
                        <>
                            <div className={modalClassName}>
                                <div>
                                    {/* <img src="http://hospitalesmac.com/img/icono_9.png" title="Pendiente de salida" alt="Pendiente de salida" height="48px" className='imgservi'/> */}
                                    {
                                        isRecuperacion?<FaHospitalUser style={styleRecuperacion}/>
                                        :isEspecial?<FaHospitalUser style={styleComplicacion}/>
                                        :<FaHospitalUser style={styleActive}/>
                                    }
                                    <h1 className='itemblogTitle'>{NumeroDePaciente.toUpperCase()}</h1>
                                    <h1 className='info_item_hospital_name'>{getUnidadHospitalariaName(unidadHospitalariaNombre,uhList)}</h1>
                                    <h1 className='info_itemblog'>{patientname}</h1>
                                    <h1 className='info_item_fecha'>Fec. Nac.: {pacienteFechaNacimiento}</h1>
                                    {
                                        telefonoIsVisible?
                                            tieneContactos?
                                                <h1 className='info_itemblog'>{NumeroTelefono}  <span className='tieneContactos' onClick={handleContactosClick()}>+</span></h1>
                                            :<h1 className='info_itemblog'>{NumeroTelefono}</h1>
                                        :null
                                    }
                                    {
                                        isRecuperacion?<h1 className='info_itemblog'>{"En recuperación"}</h1>
                                        :isEspecial?
                                            isQuirofanoOrigen?<h1 className='info_itemblog'>{"Con caso especial(Quirófano)"}</h1>
                                            :<h1 className='info_itemblog'>{"Con caso especial(Recuperación)"}</h1>
                                        :<h1 className='info_itemblog'>{"En quirófano"}</h1>
                                    }
                                    {/* <h1 className='info_item_hospital_name'>{getUnidadHospitalariaName(unidadHospitalariaNombre,uhList)}</h1> */}
                                    <p className='boton_uno' onClick={handleSalidaClick(paciente)}>Informar momento</p>
                                    {
                                        userLevel === "administrador"
                                        ?
                                            <span className='baja-cirugia' onClick={handleCancelarCirugiaClick(paciente)}>Baja Paciente</span>
                                        :
                                            null
                                    }
                                </div>
                            </div>
                        </>
                    )
                :
                    null
            }
            {
                <PacienteModal paciente={pacienteSeleccionado} isVisible={isVisible} hideModal={hideModal} uhList={uhList} 
                unidadHospitalariaNombre={pacienteUH} telefonoIsVisible={pacienteTelefonoIsVisible} 
                isRecuperacion={pacienteIsRecuperacion} setIsVisible={setIsVisible} tieneContactos={pacienteTieneContactos}
                pacienteContactos={pacienteContactos} name={name} isEspecial={pacienteIsEspecial} 
                isRecuperacionOrigen={isRecuperacionOrigen} pacienteUnidadHospitalariaName={pacienteUnidadHospitalariaName}/>
            }
        </>
        
    )
}

export default PacientePendienteAlta